import React, { useState } from 'react';

export default function ModalGrafico({ isOpen, onClose, children }) {
  const [scale, setScale] = useState(1);

  if (!isOpen) return null;

  const aumentarZoom = () => setScale(prev => Math.min(prev + 0.1, 3));
  const diminuirZoom = () => setScale(prev => Math.max(prev - 0.1, 0.5));
  const resetZoom = () => setScale(1);

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-70 flex flex-col w-screen h-screen">
      {/* Barra superior */}
      <div className="flex justify-between items-center bg-white p-2 shadow-md">
        <button
          onClick={onClose}
          className="text-gray-600 hover:text-gray-900 font-bold"
        >
          ✕ Fechar
        </button>
        <div className="space-x-2">
          <button onClick={diminuirZoom} className="px-2 py-1 bg-gray-200 rounded">-</button>
          <button onClick={resetZoom} className="px-2 py-1 bg-gray-200 rounded">Reset</button>
          <button onClick={aumentarZoom} className="px-2 py-1 bg-gray-200 rounded">+</button>
        </div>
      </div>

      {/* Área de conteúdo fullscreen */}
      <div className="flex-1 bg-white overflow-x-auto overflow-y-auto">
        <div
          style={{
            transform: `scale(${scale})`,
            transformOrigin: 'top left',
            width: '100%',
            height: '100%',
          }}
          className="flex items-center justify-center"
        >
          {/* 🔑 Aqui forçamos o gráfico a ocupar toda a tela */}
          <div className="w-full h-full">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
